<template>
    <div class="topbar-container">
        <van-tabs v-model="active" @click="loadData" :line-width="active == 0 ? 30 : 50" class="tab">
            <van-tab v-for="(item,index) in titleList" :key="index" :title="item"></van-tab>
        </van-tabs>
        <zbList v-model="store" class="v-list" :isKeep="true" itemCls="r6 list-item" v-slot:default="{ item }">
            <div class="list-item-el shadow-bg r6">
                <div class="title bh bc">
                    <div class="ico-good bg-contain"></div>
                    <div class="fz_34">{{item.orderTypeStr}}</div>
                    <div class="ico-next bg-contain"></div>
                    <div class="fz_30 b1 tr c_warning">{{item.orderStatusStr}}</div>
                </div>
                <div class="buy-list">
                    <div v-for="(item,index) in item.items" :key="index" class="cart-list-item">
                        <div class="item bh">
                            <div class="img bg-100 r6" :style="{backgroundImage: 'url(' + item.smallPic + ')'}"></div>
                            <div class="content b1">
                                <div class="fz_30 breakword">{{item.goodsName}}</div>
                                <div class="text fz_30 bh bc">
                                    <div class="bg-contain ico-maintenance"></div>
                                    <span class="c_red">{{item.goodsPrice}}</span>
                                    <div class="b1 tr c_red">x{{item.num}}件</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bh bend">
                    <van-button @click="onChangeClick(item,'cancel')" v-if="item.isPay" class="btn btn-look-mini">取消订单
                    </van-button>
                    <van-button @click="onInfoClick(item)" v-if="item.isPay" class="btn btn-pay-mini">支付订单</van-button>
                    <van-button @click="onChangeClick(item,'close')" v-if="item.isCharge" class="btn btn-pay-mini">确认收货
                    </van-button>
                    <van-button @click="onInfoClick(item)" v-if="!item.isPay" class="btn btn-look-mini">查看详情
                    </van-button>
                    <van-button class="btn btn-pay-mini" v-if="item.isReceive" @click="onReceiveClick(item.id)">领取使用
                    </van-button>
                </div>
            </div>
        </zbList>
    </div>
</template>
<script>
import { getOrderList } from "@/api/user";
import { list } from "@/mixin/list";
import { user } from "@/mixin/user";
import { changeOrder, orderInfo } from "@/api/cart";
import zbList from "@/components/data/List";
export default {
    mixins: [list, user],
    name: "UserOrder",
    components: { zbList },
    data() {
        return {
            active: 0,
            titleList: ["全部", "待付款", "待发货", "待收货", "已完成"],
            store: {
                proxy: {
                    getList: getOrderList,
                    disposeItem(item) {
                        const text = item.orderStatusStr;
                        item.isPay = text == "未支付";
                        // 是否可以收货
                        item.isCharge = item.orderType == 0 && text == "待收货";
                        // 是否是可以领取的劵
                        item.isReceive =
                            item.orderType == 2 && text == "待收货";
                    }
                }
            }
        };
    },
    computed: {
        isUpdateUserOrder() {
            return this.$store.state.cart.isUpdateUserOrder;
        }
    },
    watch: {
        // 监听是否更新订单列表数据
        isUpdateUserOrder: {
            handler(v) {
                if (v) {
                    this.storeReLoad();
                    this.$store.state.cart.isUpdateUserOrder = false;
                }
            },
            immediate: true
        }
    },
    methods: {
        // 改变订单状态
        onChangeClick(item, state) {
            let message = "确定取消订单吗？";
            if (state == "close") {
                message = "确定收货吗？";
            }
            this.dialog
                .confirm({
                    title: "提示",
                    message: message
                })
                .then(() => {
                    changeOrder(item.id, state).then(res => {
                        this.storeReLoad();
                    });
                });
        },
        // 获取用户数据后执行
        userLoginend() {
            this.loadData();
        },
        loadData(name, title) {
            const flag = name <= 2 ? (name == 0 ? "" : name - 1) : name;
            // console.log(flag, name, title, this.active);
            this.storeLoad({ orderStatus: flag });
        },
        // 查看详情
        onInfoClick(item) {
            if (item.orderTypeStr === '油卡兑换') {
                this.$router.push({
                    name: "CartOrderGasCouponInfo",
                    params: {
                        id: item.id
                    }
                });
            } else {
                this.$router.push({
                    name: "CartOrderInfo",
                    params: {
                        id: item.id
                    }
                });
            }
        },
        // 兑换
        onReceiveClick(id) {
            orderInfo(id).then(res => {
                this.$router.push({
                    name: "CartOrderExchange",
                    params: {
                        orderId: id,
                        telephone: res.data.redeemCodeBendIngTelephone
                    }
                });
            });
        }
    }
};
</script>
<style scoped lang="scss">
.v-list {
    background-color: #f7f8f8;
    height: calc(100% - 94px);
    /deep/ .list-item {
        //不能用margin,否则滚动条的高度会计算不正确
        padding: 30px 30px 0 30px;
        .ico-good {
            margin-right: 20px;
            width: 32px;
            height: 30px;
        }
        .buy-list {
            .cart-list-item {
                padding: 40px 0 0 0;
            }
        }
        &:last-child {
            padding: 30px;
        }
        .list-item-el {
            padding: 40px 30px;
        }
        .btn-look-mini,
        .btn-pay-mini {
            margin-left: 20px;
        }
    }
}
</style>
